import { DestroyRef, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthenticateRequest } from '@common/auth-strategy-credentials/shared';
import { DynamicFieldsetModule, FsOnAfterSaveEvent, ModelFormServiceFactory } from '@common/forms/frontend-shared';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { UiInputTextComponent } from '@common/ui/frontend-shared/input-text';
import { AccessFacade, AccessState, LocalMessageHandlerService, takeWhileAlive } from '@core/frontend-shared';
import { RouterLinkResolverPipe } from '@core/frontend-shared/feature';
import { ConfigService } from '@core/shared/config';
import { Store } from '@ngxs/store';
import { filter } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@core/shared/config";
import * as i3 from "@common/forms/frontend-shared";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../ui/frontend-shared/src/lib/field-wrapper/field-wrapper.component";
import * as i6 from "../../../../../ui/frontend-shared/src/lib/button/button";
import * as i7 from "../../../../../forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
const _c0 = () => ({
  label: "Login"
});
function LoginFormComponent_Conditional_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "small")(3, "a", 8);
    i0.ɵɵpipe(4, "resolveRouterLink");
    i0.ɵɵtext(5, "Passwort vergessen?");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 1, "reset-password"));
  }
}
function LoginFormComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 0)(1, "ui-field-wrapper", 1);
    i0.ɵɵelement(2, "ui-input-text", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ui-field-wrapper", 1);
    i0.ɵɵelement(4, "ui-input-text", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵelement(6, "app-messages")(7, "button", 5);
    i0.ɵɵconditionalCreate(8, LoginFormComponent_Conditional_0_Conditional_8_Template, 6, 3, "div", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.formService.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r0.usernameLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", "Passwort");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formSubmitButton", ctx_r0.formService)("formSubmitButtonOptions", i0.ɵɵpureFunction0(6, _c0));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.resetPasswordEnabled ? 8 : -1);
  }
}
export let LoginFormComponent = /*#__PURE__*/(() => {
  class LoginFormComponent {
    constructor(messages, accessFacade, config, formServiceFactory) {
      this.messages = messages;
      this.accessFacade = accessFacade;
      this.config = config;
      this.destroyRef = inject(DestroyRef);
      this.resetPasswordEnabled = true;
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
      this.usernameLabel = PLATFORM !== 'admin' && this.config.get('users.usernameIsEmail', false) ? 'E-Mail-Adresse' : 'Benutzername';
      if (config.getPlatform() === 'admin') {
        this.resetPasswordEnabled = false;
      }
      this.formService = formServiceFactory.useDestroyRef(this.destroyRef).createModelForm(AuthenticateRequest);
      this.formService.events$.pipe(takeWhileAlive(), filter(e => e instanceof FsOnAfterSaveEvent)).subscribe(({
        error
      }) => {
        if (error) {
          this.messages.push(error);
        } else {
          this.accessFacade.refreshSession();
        }
      });
      this.formService.initialize();
    }
    static {
      this.ɵfac = function LoginFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginFormComponent)(i0.ɵɵdirectiveInject(i1.LocalMessageHandlerService), i0.ɵɵdirectiveInject(i1.AccessFacade), i0.ɵɵdirectiveInject(i2.ConfigService), i0.ɵɵdirectiveInject(i3.ModelFormServiceFactory));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LoginFormComponent,
        selectors: [["auth-strategy-credentials-login-form"]],
        inputs: {
          resetPasswordEnabled: "resetPasswordEnabled"
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 1,
        vars: 1,
        consts: [["e2e-login-form", "", 3, "formGroup"], [3, "label"], ["formControlName", "username", 1, "ui-width-stretch"], ["type", "password", "formControlName", "password", 1, "ui-width-stretch"], [1, "ui-margin"], ["uiButton", "", "icon", "unlock", 1, "ui-width-stretch", 3, "formSubmitButton", "formSubmitButtonOptions"], [1, "links"], [1, "ui-text-center"], [3, "routerLink"]],
        template: function LoginFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, LoginFormComponent_Conditional_0_Template, 9, 7, "form", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.formService.initialized ? 0 : -1);
          }
        },
        dependencies: [FormsModule, i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, ReactiveFormsModule, i4.FormGroupDirective, i4.FormControlName, MinimalUiModule, i5.UiFieldWrapperComponent, i6.UiButtonComponent, UiInputTextComponent, DynamicFieldsetModule, i7.FormSubmitButtonDirective, RouterLink, AppMessagesComponent, RouterLinkResolverPipe],
        encapsulation: 2
      });
    }
  }
  return LoginFormComponent;
})();